"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSearchForm = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var formik_1 = require("formik");
var user_search_form_validation_1 = require("./user-search-form.validation");
var il_textfield_common_1 = require("../il-textfield/il-textfield.common");
var il_select_common_1 = require("../il-select/il-select.common");
var il_button_common_1 = require("../il-button/il-button.common");
var enums_1 = require("../../shared/enums");
var recentBrandLocalStorageKey = 'UserSearchForm.recentBrand';
var getRecentBrand = function () {
    var _a;
    return (_a = localStorage.getItem(recentBrandLocalStorageKey)) !== null && _a !== void 0 ? _a : enums_1.BrandEnum.MONARCH;
};
var UserSearchForm = function (props) {
    var _a = (0, formik_1.useFormik)({
        initialValues: {
            brand: getRecentBrand(),
            queryString: '',
        },
        validationSchema: user_search_form_validation_1.UserSearchFormValidation,
        onSubmit: function (values) {
            props.onSubmit(values);
        },
    }), values = _a.values, setFieldValue = _a.setFieldValue, handleSubmit = _a.handleSubmit, handleChange = _a.handleChange, errors = _a.errors, isValid = _a.isValid, dirty = _a.dirty;
    var getStartingBrand = function () {
        if (values.brand === undefined)
            return [0];
        return values.brand === enums_1.BrandEnum.MONARCH ? [0] : [1];
    };
    var setBrand = function (newBrand) {
        setFieldValue('brand', newBrand);
        localStorage.setItem(recentBrandLocalStorageKey, newBrand);
    };
    react_1.default.useEffect(function () {
        // To replace stored calvert
        localStorage.setItem(recentBrandLocalStorageKey, enums_1.BrandEnum.MONARCH);
    }, []);
    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
        react_1.default.createElement(material_1.Box, { sx: __assign({ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 2 }, props.sx) },
            react_1.default.createElement(material_1.Box, { sx: {
                    flex: 0,
                } },
                react_1.default.createElement(il_select_common_1.BrandSelect, { "data-testid": "brand-select", defaultSelections: getStartingBrand, onChange: setBrand, childSx: {
                        width: 100,
                        height: 38.5,
                    } })),
            react_1.default.createElement(material_1.Box, { sx: {
                    flex: 1,
                } },
                react_1.default.createElement(il_textfield_common_1.LoginTextField, { sx: {
                        width: 1,
                    }, "data-testid": "query-string-input", id: 'queryString', value: values.queryString, placeholder: props.inputPlaceholderText, onChange: handleChange, error: Boolean(errors.queryString), helperText: errors.queryString })),
            react_1.default.createElement(il_button_common_1.ContainedButton, { disabled: !(isValid && dirty), type: enums_1.ButtonTypeEnum.SUBMIT, sx: {
                    height: 38.5,
                    width: 200,
                } }, "Search"))));
};
exports.UserSearchForm = UserSearchForm;
